// src/pages/product/NotesPage.js
import FeaturePageTemplate from './FeaturePageTemplate';

export default function NotesPage() {
  return <FeaturePageTemplate slug="notes" />;
}